<nz-footer>Data Enhancers ©{{thisYear}} - All rights reserved - <a href="/privacy" target="_blank">Privacy</a>

</nz-footer>
